import { Col, Row } from 'react-bootstrap';
import AuditTrailBed from '../components/admin/wards/beds/AuditTrailBed';
import AdminLayout from './layout/AdminLayout';
const AuditBedList = () => {
  
    return (
        <AdminLayout>
            <Row>
                <Col className="container mb-4">
                    <AuditTrailBed />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default AuditBedList;